"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
/** Dirt simple, NOT cryptographically safe!! hasher to prevent collisions on uploaded images. */

var simpleHash = exports.simpleHash = function simpleHash(content) {
	var hash = 0;
	if (content.length === 0) return hash;
	for (var i = 0, len = content.length; i < len; i++) {
		var char = content.charCodeAt(i);
		hash = (hash << 5) - hash + char;
		hash = hash & hash;
	}
	return hash;
};


//////////////////
// WEBPACK FOOTER
// ./util/simple-hash.js
// module id = 615
// module chunks = 0